import { ApiUser } from '@allbin/mobilix-api-client';
import { DateTime } from 'luxon';

// Stable UUIDs replacing the old `auth0|…` subs (HK-1093). The stub
// provider's DEMO_UID matches tdUsers[0]. One intentional legacy
// `auth0|…` actor id is kept in testdata/events.ts to exercise the
// '<Deleted user>' rendering path.
export const tdUserIdAdmin = '6138bc01-fc28-4280-86ad-2fa430000001';
export const tdUserIdContractorAdmin = '6138bc63-2c6a-4450-8694-0ff700000002';
export const tdUserIdContractorAgent = '6138bc7a-8986-4920-86a2-43d1b0000003';
export const tdUserIdCreator = '6172bc99-5cd9-46b0-8703-39cc70000004';
export const tdUserIdStorybook = '00000000-0000-4000-8000-000000000005';

export const tdUsers: ApiUser[] = [
  {
    id: tdUserIdAdmin,
    meta: {
      created_at: DateTime.now().toISO(),
      created_by: tdUserIdCreator,
      updated_at: DateTime.now().toISO(),
    },
    email: 'mobilix-workorder-admin@allbinary.se',
    name: 'Workorder Administrator',
    user_id: tdUserIdAdmin,
    admin: true,
  },
  {
    id: tdUserIdContractorAdmin,
    meta: {
      created_at: DateTime.now().toISO(),
      created_by: tdUserIdCreator,
      updated_at: DateTime.now().toISO(),
    },
    email: 'mobilix-workorder-contractor-admin@allbinary.se',
    name: 'Workorder Contractor Admin',
    user_id: tdUserIdContractorAdmin,
    contractors: [{ id: '41c084fc-c39f-4e85-bd35-9921b5c10cc0', admin: true }],
  },
  {
    id: tdUserIdContractorAgent,
    meta: {
      created_at: DateTime.now().toISO(),
      created_by: tdUserIdCreator,
      updated_at: DateTime.now().toISO(),
    },
    email: 'mobilix-workorder-contractor-user@allbinary.se',
    name: 'Workorder Contractor Agent',
    user_id: tdUserIdContractorAgent,
    contractors: [{ id: '41c084fc-c39f-4e85-bd35-9921b5c10cc0' }],
  },
  {
    id: tdUserIdCreator,
    meta: {
      created_at: DateTime.now().toISO(),
      created_by: tdUserIdCreator,
      updated_at: DateTime.now().toISO(),
    },
    email: 'mobilix-system-admin@allbinary.se',
    name: 'System Administrator',
    user_id: tdUserIdCreator,
    admin: true,
  },
  {
    id: tdUserIdStorybook,
    meta: {
      created_at: DateTime.now().toISO(),
      created_by: tdUserIdCreator,
      updated_at: DateTime.now().toISO(),
    },
    email: 'storybook@allbinary.se',
    name: 'Storybook User',
    user_id: tdUserIdStorybook,
    admin: true,
    contractors: [],
  },
];
